enum CupsOption {
    Power,
    Month
}

//removeIf(production)
export default CupsOption;
//endRemoveIf(production)